"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartExperianBoostErrors = exports.AprType = exports.TermUnit = exports.ProductSubType = exports.ProductType = exports.GetPayoutsAccountSetUpLinkErrors = exports.GetCreditOffersErrors = exports.GetVantageScoreErrors = exports.GetAvenAdvisorCreditScoresErrors = void 0;
var GetAvenAdvisorCreditScoresErrors;
(function (GetAvenAdvisorCreditScoresErrors) {
    GetAvenAdvisorCreditScoresErrors["NEED_FULL_9_SSN"] = "NEED_FULL_9_SSN";
    GetAvenAdvisorCreditScoresErrors["REPORT_FETCH_ERROR"] = "REPORT_FETCH_ERROR";
    GetAvenAdvisorCreditScoresErrors["EXPERIAN_FROZEN_ERROR"] = "EXPERIAN_FROZEN_ERROR";
    GetAvenAdvisorCreditScoresErrors["NO_SCORE_AVAILABLE_ERROR"] = "NO_SCORE_AVAILABLE_ERROR";
    GetAvenAdvisorCreditScoresErrors["USER_IS_A_MINOR"] = "USER_IS_A_MINOR";
    GetAvenAdvisorCreditScoresErrors["USER_IS_BLOCKED"] = "USER_IS_BLOCKED";
})(GetAvenAdvisorCreditScoresErrors || (exports.GetAvenAdvisorCreditScoresErrors = GetAvenAdvisorCreditScoresErrors = {}));
var GetVantageScoreErrors;
(function (GetVantageScoreErrors) {
    GetVantageScoreErrors["NEED_FULL_9_SSN"] = "NEED_FULL_9_SSN";
    GetVantageScoreErrors["REPORT_FETCH_ERROR"] = "REPORT_FETCH_ERROR";
    GetVantageScoreErrors["USER_IS_A_MINOR"] = "USER_IS_A_MINOR";
    GetVantageScoreErrors["EXPERIAN_FROZEN_ERROR"] = "EXPERIAN_FROZEN_ERROR";
    GetVantageScoreErrors["NO_SCORE_AVAILABLE_ERROR"] = "NO_SCORE_AVAILABLE_ERROR";
})(GetVantageScoreErrors || (exports.GetVantageScoreErrors = GetVantageScoreErrors = {}));
var GetCreditOffersErrors;
(function (GetCreditOffersErrors) {
    GetCreditOffersErrors["DID_NOT_CONSENT_TO_DISCLOSURES"] = "DID_NOT_CONSENT_TO_DISCLOSURES";
    GetCreditOffersErrors["HAS_ITIN_INSTEAD_OF_SSN"] = "HAS_ITIN_INSTEAD_OF_SSN";
    GetCreditOffersErrors["NEED_FULL_9_SSN"] = "NEED_FULL_9_SSN";
    GetCreditOffersErrors["NO_CREDIT_SCORE"] = "NO_CREDIT_SCORE";
    /**
     * Even Financial returned a failure response.
     */
    GetCreditOffersErrors["OFFER_INIT_FAILURE"] = "OFFER_INIT_FAILURE";
})(GetCreditOffersErrors || (exports.GetCreditOffersErrors = GetCreditOffersErrors = {}));
var GetPayoutsAccountSetUpLinkErrors;
(function (GetPayoutsAccountSetUpLinkErrors) {
    GetPayoutsAccountSetUpLinkErrors["FAILED_TO_CREATE_CONNECTION"] = "FAILED_TO_CREATE_CONNECTION";
})(GetPayoutsAccountSetUpLinkErrors || (exports.GetPayoutsAccountSetUpLinkErrors = GetPayoutsAccountSetUpLinkErrors = {}));
/**
 * https://evenfinancial.com/docs/api-reference/#tocS_ProductType
 */
var ProductType;
(function (ProductType) {
    ProductType["credit_card"] = "credit_card";
    ProductType["insurance"] = "insurance";
    ProductType["life_insurance"] = "life_insurance";
    ProductType["loan"] = "loan";
    ProductType["mortgage"] = "mortgage";
    ProductType["savings"] = "savings";
    /**
     * This type corresponds to the 2nd Look API for special offers:
     * https://drive.google.com/file/d/1w1C9QpW1yBInNTTb2whKP-NtALuZUq7K/view
     */
    ProductType["other"] = "other";
})(ProductType || (exports.ProductType = ProductType = {}));
/**
 * https://evenfinancial.com/docs/api-reference/#tocS_ProductSubType
 */
var ProductSubType;
(function (ProductSubType) {
    ProductSubType["credit_card"] = "credit_card";
    ProductSubType["secured_card"] = "secured_card";
    ProductSubType["personal_loan"] = "personal_loan";
    ProductSubType["secured_loan"] = "secured_loan";
    ProductSubType["student_loan_refinance"] = "student_loan_refinance";
    ProductSubType["co_applicant_loan"] = "co_applicant_loan";
    ProductSubType["line_of_credit"] = "line_of_credit";
    ProductSubType["purchase"] = "purchase";
    ProductSubType["refinance"] = "refinance";
    ProductSubType["savings_account"] = "savings_account";
    ProductSubType["money_market_account"] = "money_market_account";
    ProductSubType["certificate_of_deposit"] = "certificate_of_deposit";
    ProductSubType["individual_retirement_account"] = "individual_retirement_account";
    ProductSubType["cash_management_account"] = "cash_management_account";
    ProductSubType["high_interest_checking"] = "high_interest_checking";
    ProductSubType["accidental_death_benefits"] = "accidental_death_benefits";
    ProductSubType["term_life"] = "term_life";
    ProductSubType["term_life_instant"] = "term_life_instant";
    ProductSubType["whole_life"] = "whole_life";
    ProductSubType["debt_relief"] = "debt_relief";
})(ProductSubType || (exports.ProductSubType = ProductSubType = {}));
/**
 * https://evenfinancial.com/docs/api-reference/#tocS_TermUnit
 */
var TermUnit;
(function (TermUnit) {
    TermUnit["day"] = "day";
    TermUnit["month"] = "month";
    TermUnit["year"] = "year";
    TermUnit["open"] = "open";
})(TermUnit || (exports.TermUnit = TermUnit = {}));
/**
 * https://evenfinancial.com/docs/api-reference/#tocS_AprType
 */
var AprType;
(function (AprType) {
    AprType["variable"] = "variable";
    AprType["regular"] = "regular";
    AprType["fixed"] = "fixed";
})(AprType || (exports.AprType = AprType = {}));
var StartExperianBoostErrors;
(function (StartExperianBoostErrors) {
    StartExperianBoostErrors["MISSING_CONSENT_TO_DATA_SHARING"] = "MISSING_CONSENT_TO_DATA_SHARING";
    StartExperianBoostErrors["CLIENT_ACCESS_TOKEN_GENERATION_FAILED"] = "CLIENT_ACCESS_TOKEN_GENERATION_FAILED";
    StartExperianBoostErrors["CUSTOMER_CREATION_FAILED"] = "CUSTOMER_CREATION_FAILED";
    StartExperianBoostErrors["PARTNER_LINK_TOKEN_GENERATION_FAILED"] = "PARTNER_LINK_TOKEN_GENERATION_FAILED";
    StartExperianBoostErrors["PARTNER_REDIRECT_URL_GENERATION_FAILED"] = "PARTNER_REDIRECT_URL_GENERATION_FAILED";
    StartExperianBoostErrors["USER_DATE_OF_BIRTH_MISSING"] = "USER_DATE_OF_BIRTH_MISSING";
})(StartExperianBoostErrors || (exports.StartExperianBoostErrors = StartExperianBoostErrors = {}));
